module.exports = "/React/dist/639d63f1cf06ffcb2aed6b3c06a85372.png";